import { useAuth } from "@clerk/nextjs";
import type Stripe from "stripe";
import useSWR from "swr";

import { stripeCustomerSwrOptions } from "~/lib/stripe/stripeCustomerSwrOptions";

const useStripeCustomer = () => {
	const { userId } = useAuth();

	const {
		data: customer,
		isLoading,
		mutate: refreshCustomer,
		...rest
	} = useSWR<Stripe.Customer | null>(
		userId && `/stripe/customer`,
		stripeCustomerSwrOptions,
	);

	return {
		customer,
		isLoading,
		isLoadingCustomer: isLoading,
		refreshCustomer,
		...rest,
	};
};

export default useStripeCustomer;
